/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faVideo,
  faDesktop,
  faVideoSlash,
  faMicrophoneSlash,
} from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import "./MeetingFooter.css";
import { ReactMediaRecorder } from "react-media-recorder";
import swal from 'sweetalert';
const MeetingFooter = (props) => {
  const [streamState, setStreamState] = useState({
    mic: true,
    video: false,
    screen: false,
  });
  const micClick = () => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        mic: !currentState.mic,
      };
    });
  };

  const onVideoClick = () => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        video: !currentState.video,
      };
    });
  };

  const onScreenClick = () => {
    props.onScreenClick(setScreenState);
  };

  const callDecline = () => {
    swal({
      title: "Are you sure?",
      text: "You want to leave this room",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          if (localStorage.getItem('auth_type') == 'admin') {

            window.location.href = `superstar-admin/dashboard`;
          } else {
            window.location.href = `superstar/dashboard`;
          }
        }

      });
  }

  const setScreenState = (isEnabled) => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        screen: isEnabled,
      };
    });
  };
  useEffect(() => {
    props.onMicClick(streamState.mic);
  }, [streamState.mic]);
  useEffect(() => {
    props.onVideoClick(streamState.video);
  }, [streamState.video]);
  return (
    <div className="meeting-footer">
      <div
        className={"meeting-icons " + (!streamState.mic ? "active2" : "")}
        data-tip={streamState.mic ? "Mute Audio" : "Unmute Audio"}
        onClick={micClick}
      >
        <FontAwesomeIcon
          icon={!streamState.mic ? faMicrophoneSlash : faMicrophone}
          title="Mute"
        />
      </div>
      <div
        className={"meeting-icons " + (!streamState.video ? "active2" : "")}
        data-tip={streamState.video ? "Hide Video" : "Show Video"}
        onClick={onVideoClick}
      >
        <FontAwesomeIcon icon={!streamState.video ? faVideoSlash : faVideo} />
      </div>

      {/* <div
        className="meeting-icons"
        data-tip="Share Screen"
        onClick={onScreenClick}
        disabled={streamState.screen}
      >
        <FontAwesomeIcon icon={faDesktop} />
      </div> */}


      <div className="other-icons">
        <ReactMediaRecorder
          screen
          render={({ status, startRecording, stopRecording, mediaBlobUrl }) => {
            return (
              <div className="d-flex">
                {/* <p>{status}</p> */}
                <button className="meeting-icons" data-tip="Record Video" onClick={startRecording}> <i className="fa-solid fa-record-vinyl"></i></button>
                <button className="meeting-icons" data-tip="Stop Record " onClick={stopRecording}>  <i className="fa-solid fa-hand"></i></button>
                {/* <video src={mediaBlobUrl} autoPlay loop controls></video> */}
                {mediaBlobUrl &&
                  <a
                    href={mediaBlobUrl}
                    data-tip="Download video"
                    target="_blank"
                    //  style={!mediaBlobUrl?{color:'gold'}:{color:'red'}}
                    download="My_File.mp4"
                    className='mx-2 meeting-icons'
                  >
                    <i className="fa-solid fa-download"></i>
                  </a>}


              </div>
            );
          }}
        />
      </div>

      <a style={{ textDecoration: 'none' }} href={`https://videoadmin.hellosuperstars.com?管理员密钥=${props.roomId}`} target="_blank" rel="noopener noreferrer">
        <div
          className="meeting-icons"
          data-tip="Admin Control"
        // onClick={props.perticepents}
        >
          <i className="fa fa-users" aria-hidden="true"></i>
        </div>
      </a>

      <div
        className="meeting-icons"
        data-tip="Leav Room"
        style={{ backgroundColor: 'red' }}
        // onClick={props.perticepents}
        onClick={callDecline}
      >
        <i className="fa fa-times" aria-hidden="true"></i>
      </div>








      {/* <div
        className="meeting-icons"
        data-tip="Record Video"
     
      >
        <i className="fa-solid fa-record-vinyl"></i>
    
      </div>


      <div
        className="meeting-icons"
        data-tip="Stop Record"
       
      >
        
        <i className="fa-solid fa-hand"></i>
    
      </div>

      
      <div
        className="meeting-icons"
        data-tip="Download"
    
      >
        
   
        <i className="fa-solid fa-download"></i>
      </div> */}
      <ReactTooltip />
    </div>
  );
};

export default MeetingFooter;
